var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "noticeInfo",
      style: _vm.isPage ? " height: 100vh; max-height: 100vh" : "",
      on: {
        scroll: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          $event.stopPropagation()
          return _vm.onScroll.apply(null, arguments)
        }
      }
    },
    [
      _vm.model === 1 ? _c("bloom-header") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "24px" } }),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm.isPage
          ? _c(
              "div",
              {
                staticClass: "content_header",
                staticStyle: { padding: "20px 0" }
              },
              [
                _vm.model === 1
                  ? _c(
                      "div",
                      {
                        staticClass: "content_header_h cursor",
                        on: { click: _vm.toList }
                      },
                      [_vm._v(_vm._s(_vm.$t("flowMessage12")) + ">")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "content_header_title" }, [
                  _vm._v(_vm._s(_vm.noticeTitle))
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content_box" },
          [
            _vm._l(_vm.content, function(item, index) {
              return _c(
                "div",
                { key: JSON.stringify(item) + index },
                [
                  _c("Course", {
                    ref: index,
                    refInFor: true,
                    attrs: { data: item }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("div", { staticStyle: { height: "32px" } })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "footerBtn",
          style: _vm.isPage ? "position: relative" : ""
        },
        [
          _c("div", { staticClass: "btn", on: { click: _vm.goUrl } }, [
            _vm._v(
              _vm._s(
                _vm.customWebConfig.btnText || _vm.$t("placeholders.comfirm")
              )
            )
          ]),
          _vm._v(" "),
          !_vm.isPage && _vm.noticeNo > 0
            ? _c("div", { staticClass: "listTip" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("flowMessage13")) +
                      _vm._s(_vm.noticeNo) +
                      _vm._s(_vm.$t("flowMessage14"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "color", on: { click: _vm.toNotice } },
                  [_vm._v(_vm._s(_vm.$t("flowMessage23")))]
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-14487f9b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-14487f9b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/team-message/notice-info.vue
// module id = null
// module chunks = 